import SpacedContent from './SpacedContent';

export default SpacedContent;
